// extracted by mini-css-extract-plugin
module.exports = {"stack":"styles_stack__14PUT","details":"styles_details__2Nccl","printSection":"styles_printSection__3rq62","instructions":"styles_instructions__f5_Cu"};